import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import defaultsDeep from '@df/util/fn/defaults-deep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { NSearch } from './df-search.config';

export function provideDfSearch(config?: DeepPartial<NSearch.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: NSearch.OPTIONS, useFactory: () => defaultsDeep(config, NSearch.DEFAULT_OPTIONS) }
    ]);
}
